import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { RichLogCommaMode } from "@ryde/shared";

import { IRichLogsFilter, RichLogFormFields } from "./rich-logs.models";
import { richLogCommaModeOptions } from "./rich-logs.utils";

const COMMA_MODE_LABEL = "Comma-mode";
const COMMA_MODE_LABEL_ID = "rich-log-comma-mode-label";

export const RichLogCommaModeDropdown: FC = () => {
  const { control } = useFormContext<IRichLogsFilter>();

  return (
    <Controller
      name={RichLogFormFields.commaMode}
      control={control}
      render={({ field }) => (
        <FormControl
          fullWidth
          className="log__filters--comma-mode-field"
          data-e2e="rich-log-comma-mode"
        >
          <InputLabel id={COMMA_MODE_LABEL_ID}>{COMMA_MODE_LABEL}</InputLabel>
          <Select
            labelId={COMMA_MODE_LABEL_ID}
            label={COMMA_MODE_LABEL}
            value={field.value ?? RichLogCommaMode.Or}
            onChange={event => field.onChange(event.target.value)}
          >
            {richLogCommaModeOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
};
